/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable default-case */
import React, { useMemo } from 'react';
import {
  SelectInput,
  TextArea,
  TextInput,
} from '@cochlear-design-system/foundation';

import { splitStreet } from '../../utils/address';

function checkAddValueToDropdown(value, countryStates) {
  const checkValue = (obj) => obj.value === value;
  if (countryStates.some(checkValue)) {
    return countryStates;
  }

  const countryStatesCopy = [...countryStates];
  if (value) {
    countryStatesCopy.push({ label: value, value });
    countryStatesCopy.sort((a, b) => a.label.localeCompare(b.label));
  }

  return countryStatesCopy;
}

// Helper function to get field config by id
const getFieldById = (fields, id) => fields.find((x) => x.id === id);

// Render field based on field code
const renderField = ({
  fieldCode,
  fields,
  labels,
  readOnly,
  onChange,
  onBlur,
  values,
  errors,
  countryStatesCopy,
}) => {
  switch (fieldCode) {
    case 'A': {
      const field = getFieldById(fields, 'street');
      return (
        <TextArea
          autoComplete="new-addresses"
          data-nw-input={field.id}
          readOnly={readOnly}
          name={field.name}
          id={field.id}
          label={labels[field.label]}
          optionalText={labels[field.optionalText]}
          hint={labels[field.hint]}
          promptText={labels[field.promptText]}
          onChange={onChange}
          onBlur={onBlur}
          isFluid
          value={splitStreet(values.street)}
          error={!!errors.street}
          errorMsg={errors.street}
        />
      );
    }

    case 'P': {
      const field = getFieldById(fields, 'postcode');
      return (
        <TextInput
          cssClass="is-half"
          readOnly={readOnly}
          name={field.name}
          id={field.id}
          label={labels[field.label]}
          optionalText={labels[field.optionalText]}
          hint={labels[field.hint]}
          promptText={labels[field.promptText]}
          onChange={onChange}
          onBlur={onBlur}
          value={values.postcode}
          error={!!errors.postcode}
          errorMsg={errors.postcode}
        />
      );
    }

    case 'C': {
      const field = getFieldById(fields, 'city');
      return (
        <TextInput
          readOnly={readOnly}
          name={field.name}
          id={field.id}
          label={labels[field.label]}
          optionalText={labels[field.optionalText]}
          hint={labels[field.hint]}
          promptText={labels[field.promptText]}
          onChange={onChange}
          onBlur={onBlur}
          value={values.city}
          error={!!errors.city}
          errorMsg={errors.city}
        />
      );
    }

    case 'S': {
      const field = getFieldById(fields, 'state');
      return (
        <SelectInput
          dataList={countryStatesCopy}
          isSearchable
          defaultValue={values.state}
          disabled={readOnly}
          name={field.name}
          id={field.name}
          label={labels[field.label]}
          optionalText={labels[field.optionalText]}
          hint={labels[field.hint]}
          promptText={labels[field.promptText]}
          onChange={onChange}
          onBlur={onBlur}
          error={!!errors.state}
          errorMsg={errors.state}
        />
      );
    }

    default:
      return null;
  }
};

export const CalculatedAddress = (props) => {
  const {
    config,
    labels,
    readOnly,
    onChange,
    onBlur,
    values,
    errors,
    touched,
    countryStates,
  } = props;

  const { fields } = config;

  const countryStatesCopy = useMemo(
    () => checkAddValueToDropdown(values.state, countryStates),
    [values.state, countryStates],
  );

  // Parse display format once
  const formatLetters = useMemo(
    () => config.displayFormat.split(''),
    [config.displayFormat],
  );

  return (
    <div className="ccl-c-city-state">
      {formatLetters.map((s) => {
        const fieldCode = s.toUpperCase();
        const fullWidth = s === fieldCode; // uppercase = full width
        const cssClass = fullWidth
          ? 'ccl__column'
          : 'ccl__column is-half-inline';

        return (
          <div
            key={fieldCode}
            className={`${cssClass} field-${fieldCode.toLowerCase()}`}
          >
            {renderField({
              fieldCode,
              fields,
              labels,
              readOnly,
              onChange,
              onBlur,
              values,
              errors,
              touched,
              countryStatesCopy,
            })}
          </div>
        );
      })}
    </div>
  );
};
